export const PAGE_META = {
  home: {
    path: "/",
    title: "VCO Group | Commercial & Industrial Masonry and Siding Specialists",
    description:
      "VCO Group delivers commercial and industrial masonry, bricklaying, and siding, backed by full project management from planning through delivery. Based in Mississauga, ON.",
  },
  services: {
    path: "/services",
    title: "Services | Masonry, Siding & Construction Project Management — VCO Group",
    description:
      "Masonry & bricklaying, siding & exterior cladding, and full project management for commercial and industrial construction — delivered by VCO Group.",
  },
  about: {
    path: "/about",
    title: "About VCO Group | Commercial & Industrial Masonry and Siding Experts",
    description:
      "VCO Group is a Mississauga-based commercial and industrial construction company specializing in masonry and siding, with full project management capability.",
  },
  projects: {
    path: "/projects",
    title: "Projects | VCO Group Masonry & Siding Portfolio",
    description:
      "A selection of commercial and industrial masonry, siding, and construction management projects delivered by VCO Group.",
  },
  contact: {
    path: "/contact",
    title: "Contact VCO Group | Mississauga, ON",
    description:
      "Get in touch with VCO Group for your next commercial or industrial masonry, siding, or construction project.",
  },
};
